/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HospitalProcedure from './hospital-procedure';
import HospitalProcedureDetail from './hospital-procedure-detail';
import HospitalProcedureUpdate from './hospital-procedure-update';
import HospitalProcedureDeleteDialog from './hospital-procedure-delete-dialog';

const HospitalProcedureRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HospitalProcedure />} />
    <Route path="new" element={<HospitalProcedureUpdate />} />
    <Route path=":id">
      <Route index element={<HospitalProcedureDetail />} />
      <Route path="edit" element={<HospitalProcedureUpdate />} />
      <Route path="delete" element={<HospitalProcedureDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospitalProcedureRoutes;
